
































































import { __ } from 'bits/intl'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { navigateTo, transformUrl } from 'bits/location'
import OzContainedButton, { OzContainedButtonColorScheme } from 'library/v4/components/OzContainedButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzLoadingSpinner from 'library/v4/components/OzLoadingSpinner.vue'
import { UpgradeSource } from 'vuexstore/modules/plans'
import { getFormattedPlanPriceToDisplay } from 'bits/billing_helper'

export enum Tier {
  Gold = 'Gold',
  Platinum = 'Platinum',
}

export enum PaymentSchedule {
  Monthly = 'Monthly',
  Annual = 'Annual',
}

const browser = namespace('browser')
const plans = namespace('plans')

@Component({ components: { OzContainedButton, OzIcon, OzLoadingSpinner } })
export default class PaymentScheduleTier extends Vue {
  @browser.Getter isPhone!: boolean
  @plans.Getter plans
  @plans.Getter plansFetched!: boolean
  @Prop() tier!: Tier
  @Prop() paymentSchedule!: PaymentSchedule
  @Prop({ default: true }) useTierColor!: boolean
  @Prop() upgradeSource!: UpgradeSource | null

  getFormattedPlanPriceToDisplay = getFormattedPlanPriceToDisplay
  OzContainedButtonColorScheme = OzContainedButtonColorScheme
  PaymentSchedule = PaymentSchedule
  Tier = Tier

  get buttonColorScheme(): OzContainedButtonColorScheme {
    if (!this.useTierColor) return OzContainedButtonColorScheme.Primary
    if (this.tier === Tier.Gold) return OzContainedButtonColorScheme.Orange
    return OzContainedButtonColorScheme.Green
  }

  navigateToCheckout(): void {
    const searchParams = new URLSearchParams({ upgrade_source: this.upgradeSource || '' })
    if (this.tier === Tier.Gold && this.paymentSchedule === PaymentSchedule.Monthly)
      navigateTo(transformUrl(this.plans.gold.monthly.url, { searchParams }))
    if (this.tier === Tier.Gold && this.paymentSchedule === PaymentSchedule.Annual)
      navigateTo(transformUrl(this.plans.gold.annual.url, { searchParams }))

    if (this.tier === Tier.Platinum && this.paymentSchedule === PaymentSchedule.Monthly)
      navigateTo(transformUrl(this.plans.platinum.monthly.url, { searchParams }))
    if (this.tier === Tier.Platinum && this.paymentSchedule === PaymentSchedule.Annual)
      navigateTo(transformUrl(this.plans.platinum.annual.url, { searchParams }))
  }
}
